import {
  SharedModule,
  TypedBaseListComponent,
  DataService,
  ModalService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import { Component, OnInit } from "@angular/core";
import {
  GetNoticesDocument,
  NoticeType,
  GetNewNoticesDocument,
} from "src/generated-gql/graphql";
import { take } from "rxjs";

@Component({
  selector: "notice-table",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./notice-table.component.html",
})
export class NoticeTableComponent
  extends TypedBaseListComponent<typeof GetNewNoticesDocument, "notices">
  implements OnInit
{
  constructor(
    protected dataService: DataService,
    protected modalService: ModalService,
    protected notificationService: NotificationService
  ) {
    super();

    this.route.url.pipe(take(1)).subscribe((res) => {
      let stateFilter = NoticeType.Notice;
      if (res.length > 0) {
        const url = res[0];
        if (url.path.includes("winner-announcement")) {
          stateFilter = NoticeType.WinnerAnnouncement;
        }
      }
      super.configure({
        document: GetNoticesDocument,
        getItems: (result) => result.notices,
        setVariables: (skip, take) => ({
          options: {
            skip,
            take,
            filter: {
              type: {
                eq: stateFilter,
              },

              nTitle: this.searchTermControl.value
                ? {
                    contains: this.searchTermControl.value,
                  }
                : undefined,

              ...this.filters.createFilterInput(),
            },
            sort: this.sort.createSortInput(),
          },
        }),
        refreshListOnChanges: [
          this.filters.valueChanges,
          this.sort.valueChanges,
          this.searchTermControl.valueChanges,
        ],
      });
    });
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addDateFilters()
    .connectToRoute(this.route);

  readonly sort = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .addSorts([
      { name: "id" },
      { name: "nTitle" },
      { name: "updatedAt" },
      { name: "createdAt" },
    ]);
}
